import MentoringTimeMeeting from './MentoringTimeMeeting.vue';

export default MentoringTimeMeeting;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/modal/components/meeting/components/timeandaddress/index.ts